import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-contact-icon/jb-contact-icon.css.ts
var jb_contact_icon_css_default = i`:host{font-family:var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);font-weight:var(--theme-font-regular-weight, 400)}:host{font-size:var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem)}:host{align-items:center;color:inherit;cursor:pointer;display:var(--display, inline-flex);gap:var(--theme-spacing-3xs)}svg{block-size:24px;display:inline-block;fill:currentcolor;inline-size:24px;margin-inline-end:-2px;overflow:visible;padding:2px;transform-origin:center;transition:rotate .5s ease-in-out}:host(:hover) svg{rotate:15deg}`;

export {
  jb_contact_icon_css_default
};
